import React, { Fragment } from 'react';
import parkinghub from '../../../../../images/ParkingLots/Instructions/SF/mapview.jpeg';
import parkinghub2 from '../../../../../images/ParkingLots/Instructions/SF/embarcadero.jpeg';
import '../../driverFaq.css';
import WalkingAccess from './WalkingAccess';
import PersonalVehicleAccess from './PersonalVehicleAccess';

const ParkingHub = () => (
  <Fragment>
    <p style={{ color: 'grey' }}>
      San Francisco Downtown - 3 Embarcadero Center, San Francisco, CA
      94111
    </p>
    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
      <li>
        Location: Three Embarcadero Center, underground parking facility
      </li>
      <li>
        Address: 3 Embarcadero Ctr, (Level B) San Francisco, CA 94111
      </li>
      <li>
        Intersection: Drumm Street/Sacramento Street or Davis
        Street/Sacramento Street
      </li>
      <li>Closest subway stations: Embarcadero station</li>
    </ul>
    <br />
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
      <img src={parkinghub} className="hub-location-image" />
      <img src={parkinghub2} className="hub-location-image" />
    </div>
    <br />
    <p>
      Autzu EV vehicles are parked on Level A in the Three Embarcado Center
      underground parking facility. The parking lot is a 3-minute walk from
      the Embarcadero BART or Muni stations.
    </p>
    <br />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot by walking?
    </p>
    <WalkingAccess />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot with my personal vehicle? (free
      parking)
    </p>
    <PersonalVehicleAccess />
  </Fragment>
);

export default ParkingHub;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Embarcadero/ParkingHub.js